import React from 'react';
import Uganda_p5 from './uganda_p5';

import Uganda_p5_subjects from './uganda_p5_subjects';

const Uganda_p5math = () => {
  return (
    <>
    <Uganda_p5 />
    <Uganda_p5_subjects />
    <div className=' grid relative right-0 left-0 top-37 '>
      <div className='card'>
        <h3>K-5 Mathematics by Topics</h3>
        <p>1. Count up to 5.</p>
        <p>2. Count up to 10.</p>
        <p>3. Count up to 20.</p>
      </div>
      <div className='card'>
        <h3>K-5 Mathematics by skill area</h3>
        <p>1. Spatial reasoning.</p>
        <p>2. Computational reasoning.</p>
        <p>3. Logical reasoning.</p>
      </div>
      <div className='card'>
        <h3>K-5 week by week</h3>
        <p>1. Spatial reasoning.</p>
        <p>2. Computational reasoning.</p>
        <p>2. Logical reasoning.</p>
      </div>
      <div className='card'>
        <h3>K-5 Mathematics skill area</h3>
        <p>1. Spatial reasoning.</p>
        <p>2. Computational reasoning.</p>
        <p>2. Logical reasoning.</p>
      </div>
    </div>
    </>
  );
}

export default Uganda_p5math;